import { css } from "@compiled/react";

import { JiraOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation, {
    JoinableSites
} from "@/components/signup/site-activation";

import {
    Headings,
    JoinableSitesText,
    WelcomeBackText
} from "../../../components";

export const CurrentProductJoinableUser = () => {
    return (
        <JiraOverlayTemplate size="sm">
            <div css={containerCss}>
                <Headings
                    main={<WelcomeBackText />}
                    sub={<JoinableSitesText />}
                />
                <SiteActivation
                    CurrentProductJoinableUser={<JoinableSites />}
                    useContactExpandCohortLogic={true}
                />
            </div>
        </JiraOverlayTemplate>
    );
};

const containerCss = css({
    display: "grid",
    gap: "10px"
});
